import { NgClass } from "@angular/common";
import { Component, Input } from "@angular/core";

@Component({
  selector: "app-icon-top-arrow",
  imports: [NgClass],
  templateUrl: "./icon-top-arrow.component.html",
  styleUrl: "./icon-top-arrow.component.scss",
})
export class IconTopArrowComponent {
  @Input() active: boolean = false;
}
